import { Badge, Box, Divider, Flex, Heading, Icon, Link, Text } from '@chakra-ui/react';
import { FaRegClock } from 'react-icons/fa';

import { MAIN_NUMBER } from '../../../../constants/contact';

const ExtendedProcessingPayoff = () => {
  return (
    <Box>
      <Flex mb={4}>
        <Box mr={4}>
          <Flex
            boxSize={8}
            rounded="full"
            p={1}
            bgColor="yellow.100"
            alignItems="center"
            justifyContent="center"
          >
            <Icon as={FaRegClock} color="yellow.500" />
          </Flex>
        </Box>
        <Box>
          <Badge variant="outline" colorScheme="yellow" my={2}>
            EXTENDED PROCESSING
          </Badge>
          <Text color="gray.600">RETRIEVING YOUR PAYOFF</Text>
          <Heading as="h3" fontSize="xx-large" fontWeight="bold">
            Still working on it
          </Heading>
        </Box>
      </Flex>
      <Divider my={4} />
      <Text fontSize="sm" color="gray.600">
        We’re still trying to retrieve your official payoff amount from your lender. Sometimes
        lenders require additional time or other additional information before they send it back.
        We’ll update this page as soon as your payoff is available. If you need to move forward
        sooner, give us a call at <Link href={`tel:+1-${MAIN_NUMBER}`}>{MAIN_NUMBER}</Link>.
      </Text>
    </Box>
  );
};

export default ExtendedProcessingPayoff;
